import { isRouteErrorResponse, Link, useRouteError } from "react-router";
import { isChunkError as chunkError, reloadForNewBuild } from "../../helpers/staleBuildReload";

// Root errorElement: replaces React Router's developer screen ("Unexpected
// Application Error!") with a page a visitor can act on. A failed lazy chunk
// (new deploy while the tab was open, flaky network) is fixed by a reload.
export function RouteError() {
  const error = useRouteError();
  const isChunkError = chunkError(error);
  // Новая версия сайта: сначала сами перезагружаем страницу (один раз);
  // экран ниже виден, только если и после этого не загрузилось.
  if (isChunkError && reloadForNewBuild()) return null;

  if (import.meta.env.DEV) console.error(error);

  const title = isRouteErrorResponse(error)
    ? `Ошибка ${error.status}`
    : isChunkError
      ? "Сайт обновился"
      : "Что-то пошло не так";
  const text = isChunkError
    ? "Мы выпустили новую версию сайта. Обновите страницу, чтобы продолжить."
    : "Попробуйте обновить страницу. Если ошибка повторится, вернитесь на главную.";

  return (
    <main className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4 py-24">
      <h1 className="text-3xl sm:text-4xl font-black text-gray-900 mb-3">{title}</h1>
      <p className="text-gray-600 max-w-md mb-8">{text}</p>
      <div className="flex flex-wrap gap-3 justify-center">
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="px-6 py-3 rounded-xl bg-blue-700 hover:bg-blue-800 text-white font-semibold transition"
        >
          Обновить страницу
        </button>
        <Link
          to="/"
          reloadDocument
          data-reload
          className="px-6 py-3 rounded-xl border border-gray-300 hover:border-blue-500 text-gray-800 font-semibold transition"
        >
          На главную
        </Link>
      </div>
    </main>
  );
}
